import * as React from 'react';
import { SVGProps } from 'react';

const SvgRibbon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="m29.285 36.875-8.193-8.192 3.639-3.639 4.538 4.54.016 7.29Z"
    />
    <path
      fill="currentColor"
      d="m13.595 36.314-5.47-5.46 6.654-6.648-2.213-2.198a14.485 14.485 0 0 1-3.16-4.631 8.548 8.548 0 0 1-.782-3.299A11.594 11.594 0 0 1 20.203 2.5 11.589 11.589 0 0 1 31.78 14.078c0 3.304-2.161 6.176-3.978 7.982L13.595 36.314Zm-1.816-5.46 1.816 1.822 12.417-12.422c1.204-1.205 3.227-3.603 3.227-6.176a9.016 9.016 0 0 0-9.006-9.005 9.016 9.016 0 0 0-9.005 9.005 6.22 6.22 0 0 0 .576 2.296 11.995 11.995 0 0 0 2.61 3.802l2.186 2.187 1.822-1.816-2.696-2.655a5.964 5.964 0 0 1-1.302-1.961 5.825 5.825 0 0 1 .87-5.964 6.433 6.433 0 0 1 4.93-2.3 6.458 6.458 0 0 1 5.207 2.655 5.82 5.82 0 0 1 .633 5.511 5.912 5.912 0 0 1-1.333 2.059L11.779 30.854Zm8.454-20.63a3.863 3.863 0 0 0-2.959 1.38 3.304 3.304 0 0 0-.457 3.339c.168.417.42.796.74 1.112l2.687 2.69 2.68-2.675a3.38 3.38 0 0 0 .747-1.143 3.252 3.252 0 0 0-.299-3.087 3.885 3.885 0 0 0-3.149-1.616h.01Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M24.244 5.3c1.775 1.544 2.707 3.33 2.768 5.27.13 4.075-3.602 7.775-6.334 10.477l-.592.57M15.772 5c-1.776 1.544-2.707 3.33-2.769 5.27-.128 4.075 3.602 7.775 6.335 10.477l.592.57"
    />
  </svg>
);

export default SvgRibbon;
